import './Device.css';

import React from 'react'

export function DeviceLayout({children}) {
  return (
    <div id="device">
      {children}
    </div>
  )
}

export function PCDevice(){
  return (
    <>
      <div id="device_pc" className="content_wrapper">
        <div className="header">
          <div className="header_logo"><img src="./pc/images/header_logo2.png" width="215px" alt="みつけて！おっとっと" /></div>
        </div>
        <div className="content_outer">
          <div className="content_inner">
            <div className="pt40"><img src="./pc/images/img_logo.png" alt="ポケットモンスター" /></div>
            <div className="mt20"><img src="./pc/images/img_attention.png" alt="" /></div>
            <div className="mt40"><img src="./pc/images/img_text.png" alt="本コンテンツはスマートフォン専用のため、PCではご利用頂けません。下記QRコードよりスマートフォンからアクセスをお願いします。" /></div>
            <div className="mt30 pb40">
              <div className="qr_img"><img src="./pc/images/img_qr.png" width="100%" alt="" /></div>
            </div>
          </div>
        </div>
        <div className="footer"><img src="./pc/images/img_copyright.png" alt="©Nintendo･Creatures･GAME FREAK･TV Tokyo･ShoPro･JR Kikaku ©Pokémon" /></div>
      </div>
    </>
  )
}

export function IOSDevice() {

  return (
    <>
      <div id="alert_web" className="content_wrapper">
        <h1><img src="./images/alert/header_logo.png" width="100%" alt="おっとっと"/></h1>
        <div className="mb55"><img src="./images/alert/img_title.png" width="100%" alt="ポケットモンスター" /></div>
        <div className="ml40 mr40 mb75 left">
          <div className="mb50 bold">本コンテンツの推奨ブラウザはSafari、Chromeになります。推奨ブラウザにてアクセスをお願いします。</div>
          <div className="list_notice">推奨動作環境は、Android11.0以上<br />（Chrome）/ iOS15以上（safari）となります</div>
          <div className="list_attention">推奨動作環境であっても、古い端末や一部端末、端末の設定によっては動作しない場合がございます。ご了承下さい</div>
          <div className="list_attention">お使いのブラウザによりボタンの配置場所は異なりますが、こちらのマーク(ボタン)から、Safariを開いてください</div>
        </div>

        <div className="mb60"><img src="./images/alert/txt_ios.png" width="41.718%" alt="iPhoneの場合" /></div>
        <div className="mb40"><img src="./images/alert/ios_step1.png" width="68.75%" alt="（例）LINEの場合 1.右上のボタンをタップ" /></div>
        <div className="mb40"><img src="./images/alert/icon_arrow.png" width="15.312%" alt="" /></div>
        <div className="mb40"><img src="./images/alert/ios_step2.png" width="68.75%" alt="2.Safariで開くをタップ" /></div>
        <div className="mb40"><img src="./images/alert/icon_arrow.png" width="15.312%" alt="" /></div>
        <div className="mb40"><img src="./images/alert/ios_step3.png" width="68.75%" alt="3.Safariブラウザでページを開いてコンテンツを遊ぼう！" /></div>
        <div className="pb30"><img src="./images/copyright.png" width="55.46875%" alt="©Nintendo･Creatures･GAME FREAK･TV Tokyo･ShoPro･JR Kikaku ©Pokémon" /></div>
    </div>
    </>
  )
}

export function AndroidDevice() {

  return (
    <>
      <div id="alert_web" className="content_wrapper">
        <h1><img src="./images/alert/header_logo.png" width="100%" alt="おっとっと"/></h1>
        <div className="mb55"><img src="./images/alert/img_title.png" width="100%" alt="ポケットモンスター" /></div>
        <div className="ml40 mr40 mb75 left">
          <div className="mb50 bold">本コンテンツの推奨ブラウザはSafari、Chromeになります。推奨ブラウザにてアクセスをお願いします。</div>
          <div className="list_notice">推奨動作環境は、Android11.0以上<br />（Chrome）/ iOS15以上（safari）となります</div>
          <div className="list_attention">推奨動作環境であっても、古い端末や一部端末、端末の設定によっては動作しない場合がございます。ご了承下さい</div>
          <div className="list_attention">お使いのブラウザによりボタンの配置場所は異なりますが、こちらのマーク(ボタン)から、Safariを開いてください</div>
        </div>

        <div className="mb75"><img src="./images/alert/txt_android.png" width="45.468%" alt="Androidの場合" /></div>
        <div className="mb35"><img src="./images/alert/android_step1.png" width="68.75%" alt="（例）LINEの場合 1.右上のボタンをタップ" /></div>
        <div className="mb35"><img src="./images/alert/icon_arrow.png" width="16.875%" alt="" /></div>
        <div className="mb35"><img src="./images/alert/android_step2.png" width="68.75%" alt="2.他のアプリで開くをタップ " /></div>
        <div className="mb35"><img src="./images/alert/icon_arrow.png" width="16.875%" alt="" /></div>
        <div className="mb55"><img src="./images/alert/android_step3.png" width="68.75%" alt="3.推奨ブラウザでページを開いてコンテンツを遊ぼう！" /></div>
        <div className="pb30"><img src="./images/copyright.png" width="55.46875%" alt="©Nintendo･Creatures･GAME FREAK･TV Tokyo･ShoPro･JR Kikaku ©Pokémon" /></div>
      </div>
    </>
  )
}